import { Button } from '@heroui/react'
import type { ModalComponentProps } from '@qse/constants'
import { useActiveModelStore } from '@qse/stores'

interface NavigationWarningData {
  title?: string
  message?: string
  proceedButtonText?: string
  cancelButtonText?: string
  onProceed?: () => void
  onCancel?: () => void
}

export default function NavigationWarningModal(props: ModalComponentProps) {
  const { setModelActive, onClose } = props
  const { data } = useActiveModelStore()

  const config = data as NavigationWarningData

  const handleProceed = () => {
    if (config?.onProceed) {
      config.onProceed()
    }
    setModelActive(undefined)
    onClose()
  }

  const handleCancel = () => {
    if (config?.onCancel) {
      config.onCancel()
    }
    setModelActive(undefined)
    onClose()
  }

  const defaultTitle = 'Navigation Warning'
  const defaultMessage =
    'You have an operation in progress. Are you sure you want to leave this page? Any unsaved progress will be lost.'
  const defaultProceedText = 'Leave Page'
  const defaultCancelText = 'Stay on Page'

  return (
    <div className="h-full">
      <div className="relative z-10 h-full flex flex-col justify-center items-center">
        <div className="w-[400px] my-8 flex flex-col justify-center items-center text-center gap-5">
          <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center">
            <img alt="warning" className="w-8 h-8" src="/assets/svg/warning.svg" />
          </div>

          <h1 className="font-medium text-xl">{config?.title || defaultTitle}</h1>

          <p className="text-gray-300 leading-relaxed text-sm">
            {config?.message || defaultMessage}
          </p>
        </div>
      </div>

      <div className="flex justify-end pb-4 gap-3 w-full">
        <Button fullWidth color="default" radius="sm" onPress={handleCancel}>
          {config?.cancelButtonText || defaultCancelText}
        </Button>
        <Button fullWidth color="danger" radius="sm" variant="solid" onPress={handleProceed}>
          {config?.proceedButtonText || defaultProceedText}
        </Button>
      </div>
    </div>
  )
}
